import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';

// Layouts
import PublicLayout from './layouts/PublicLayout';
import AdminLayout from './layouts/AdminLayout';

// Public Pages
import HomePage from './pages/public/HomePage';
import AboutPage from './pages/public/AboutPage';
import ServicesPage from './pages/public/ServicesPage';
import ServiceDetailPage from './pages/public/ServiceDetailPage';
import LawyersPage from './pages/public/LawyersPage';
import LawyerDetailPage from './pages/public/LawyerDetailPage';
import OfficesPage from './pages/public/OfficesPage';
import BookingPage from './pages/public/BookingPage';
import CheckStatusPage from './pages/public/CheckStatusPage';
import ContactPage from './pages/public/ContactPage';
import LegalPage from './pages/public/LegalPage';

// Admin Pages
import AdminLoginPage from './pages/admin/AdminLoginPage';
import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import AdminAppointmentsPage from './pages/admin/AdminAppointmentsPage';
import AdminCalendarPage from './pages/admin/AdminCalendarPage';
import AdminLawyersPage from './pages/admin/AdminLawyersPage';
import AdminServicesPage from './pages/admin/AdminServicesPage';
import AdminOfficesPage from './pages/admin/AdminOfficesPage';
import AdminWorkingHoursPage from './pages/admin/AdminWorkingHoursPage';
import AdminClientsPage from './pages/admin/AdminClientsPage';
import AdminReviewsPage from './pages/admin/AdminReviewsPage';
import AdminCmsPage from './pages/admin/AdminCmsPage';
import AdminContactPage from './pages/admin/AdminContactPage';
import AdminSocialPage from './pages/admin/AdminSocialPage';
import AdminNotificationsPage from './pages/admin/AdminNotificationsPage';
import AdminTranslationsPage from './pages/admin/AdminTranslationsPage';
import AdminMediaPage from './pages/admin/AdminMediaPage';
import AdminSettingsPage from './pages/admin/AdminSettingsPage';
import AdminUsersPage from './pages/admin/AdminUsersPage';
import AdminActivityLogsPage from './pages/admin/AdminActivityLogsPage';
import AdminSubscriptionsPage from './pages/admin/AdminSubscriptionsPage';
import AdminChatMonitoringPage from './pages/admin/AdminChatMonitoringPage';
import AdminLawyerChatPage from './pages/admin/AdminLawyerChatPage';
import ScrollToTop from './components/common/ScrollToTop';

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <LanguageProvider>
        <AuthProvider>
          <Routes>
            {/* Public Website Routes */}
            <Route element={<PublicLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/services/:slug" element={<ServiceDetailPage />} />
              <Route path="/lawyers" element={<LawyersPage />} />
              <Route path="/lawyers/:slug" element={<LawyerDetailPage />} />
              <Route path="/offices" element={<OfficesPage />} />
              <Route path="/book" element={<BookingPage />} />
              <Route path="/check-status" element={<CheckStatusPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/privacy-policy" element={<LegalPage />} />
              <Route path="/terms-of-service" element={<LegalPage />} />
              <Route path="/disclaimer" element={<LegalPage />} />
            </Route>

            {/* Admin Authentication */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/login" element={<Navigate to="/admin/login" replace />} />
            <Route path="/admin-login" element={<Navigate to="/admin/login" replace />} />

            {/* Admin Dashboard Routes (Protected) */}
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="dashboard" element={<AdminDashboardPage />} />
              <Route path="appointments" element={<AdminAppointmentsPage />} />
              <Route path="calendar" element={<AdminCalendarPage />} />
              <Route path="lawyers" element={<AdminLawyersPage />} />
              <Route path="services" element={<AdminServicesPage />} />
              <Route path="offices" element={<AdminOfficesPage />} />
              <Route path="working-hours" element={<AdminWorkingHoursPage />} />
              <Route path="clients" element={<AdminClientsPage />} />
              <Route path="reviews" element={<AdminReviewsPage />} />
              <Route path="cms" element={<AdminCmsPage />} />
              <Route path="contact" element={<AdminContactPage />} />
              <Route path="social" element={<AdminSocialPage />} />
              <Route path="notifications" element={<AdminNotificationsPage />} />
              <Route path="translations" element={<AdminTranslationsPage />} />
              <Route path="media" element={<AdminMediaPage />} />
              <Route path="settings" element={<AdminSettingsPage />} />
              <Route path="users" element={<AdminUsersPage />} />
              <Route path="activity-logs" element={<AdminActivityLogsPage />} />
              <Route path="subscriptions" element={<AdminSubscriptionsPage />} />
              <Route path="chats" element={<AdminChatMonitoringPage />} />
              <Route path="lawyer-chat" element={<AdminLawyerChatPage />} />
            </Route>

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}
